import Enumerable from "linq";
import {
  User,
  UserDetail,
  IUserRepository,
  IUserFilterParameter,
  Profession,
} from "../../../domain/user";
import {
  AuthenticatedCachedRepository,
  AuthenticatedHttpClient,
} from "../..";
import { IUserBean, IUserDetailBean } from "./beans";
import { DesignatedDoctorRepository } from "./DesignatedDoctorRepository";

// TODO: 職員情報はキャッシュしちゃダメ.フィルタ実装も含めて見直す事.
export class UserRepository extends AuthenticatedCachedRepository<string, User> implements IUserRepository {
  constructor(getToken: () => string) {
    super(new AuthenticatedHttpClient(getToken), UserRepository.createCache, UserRepository.areIdsEqual);
  }

  public async getEntities(filter: IUserFilterParameter): Promise<User[]> {
    // TODO: 職員情報はキャッシュしちゃダメ.フィルタ実装も含めて見直す事.
    console.warn("TODO:職員情報はキャッシュしないよう対応要.バックエンド対応待ち.");
    return this.getAllEntities();
  }

  private static async createCache(client: AuthenticatedHttpClient): Promise<User[]> {
    const url = "/api/users";
    const result = await client.get(url);
    return UserRepository.toUsers(result.data);
  }

  private static toUsers(users: IUserBean[]): User[] {
    const results: User[] = [];
    for (const user of users) {
      results.push(UserRepository.toUser(user));
    }
    return results;
  }

  public static toUser(bean: IUserBean): User {
    if (!bean) { return null; }
    return Object.freeze(new User(
      bean.code,
      bean.name,
      bean.profession ? new Profession(bean.profession, bean.professionName, "") : null, // TODO 将来的にはcategoryを入れてもらいたい
      bean.kanaName,
      bean.email,
      bean.phone,
    ));
  }

  private static areIdsEqual(source: string, destination: string): boolean {
    return (source.toUpperCase() === destination.toUpperCase());
  }

  public async getDepartmentUsers(id: string, shouldFilterByMainDepartment: boolean): Promise<User[]> {
    if (!id || id === "") { throw new Error("id is empty!!!"); }
    const url = "/api/departments/" + id + "/users";
    const query = {
      params: {
        shouldFilterByMainDepartment: shouldFilterByMainDepartment,
      }
    };
    const result = await this.get(url, query);
    return UserRepository.toUsers(result.data);
  }

  public async getAllUsers(shouldIncludeExpired: boolean): Promise<User[]> {
    const url = "/api/users";
    const query = {
      params: {
        shouldIncludeExpired: shouldIncludeExpired,
      }
    };
    const result = await this.get(url, query);
    return UserRepository.toUsers(result.data);
  }

  public async getUserDetail(id: string): Promise<UserDetail> {
    const url = "/api/user/" + id + "/detailinfo";
    const result = await this.get(url);
    return UserRepository.toUserDetail(result.data);
  }

  private static toUserDetail(bean: IUserDetailBean): UserDetail {
    return Object.freeze(new UserDetail(
      Enumerable.from(bean.designatedDoctors)
        .select(DesignatedDoctorRepository.toDesignatedDoctorInformation)
        .toArray(),
      bean.userComment,
      bean.updateUserName,
      bean.updateDateTime,
    ));
  }

  public async getBelongedAllDepartmentsUsers(): Promise<User[]> {
    const url = "/api/users/belonged-all-departments";
    const result = await this.get(url);
    return UserRepository.toUsers(result.data);
  }

  public async setUserComment(id: string, comment: string): Promise<void> {
    const url = "api/user-comment/save";
    const sendData = {
      token: this.token,
      userCode: id,
      userComment: comment,
    };
    await this.post(url, sendData);
  }

  public async getAuthorizedUsers(): Promise<User[]> {
    const url = "/api/users/maintenance-access";
    const result = await this.get(url);
    return UserRepository.toUsers(result.data);
  }

  public async setAuthorizedUsers(ids: string[]): Promise<void> {
    const url = "/api/users/maintenance-access/save";
    const sendData = {
      token: this.token,
      userCodes: ids,
    };
    await this.post(url, sendData);
  }
}
